export default __webpack_public_path__ + "static/media/aerial_3.518a31a9.jpg";